import React from 'react';
import styled, { keyframes } from 'styled-components';

const backgroundFadeIn = keyframes`
  from {
    background-color: #fff;
  }
  to {
    background-color: #444;
  }
`;

const fall = keyframes`
  from {
    top: 100vh;
  }
  to {
    top: 0vh;
  }
`;

const Wrapper = styled.div`
  margin: 0px auto;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  filter: brightness(40%);

  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000;
  animation: ${backgroundFadeIn} 2s forwards;
  animation-delay: 2s;
`;

const WIDTHS = {
  small: '100px',
  medium: '200px',
  large: '300px',
};

const OFFSETS = [ '5vw', '20vw', '30vw', '40vw', '50vw', '60vw', '70vw', '80vw', '90vw', ];

const INDEX = {
  small: 1,
  medium: 2,
  large: 3,
};

const Card = styled.img`
  position: absolute;
  top: 0;
  top: -100vh;
  animation: ${fall};
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  color: white;
  background-color: #444;
  box-shadow: 0px 5px 10px rgba(0,0,0,.5);

  width: ${props => WIDTHS[props.size]};

  animation-duration: ${props => (Math.random() * 4) + 12}s;
  animation-delay: ${props => (Math.random() * 10)}s;
  left: ${props => OFFSETS[props.index]};

  z-index: ${props => INDEX[props.size]};
`;

const FallingCards = () => (
  <Wrapper>	
    <Card size="large" index="0" src="/images/falling-cards/lg-1.jpg" />
    <Card size="medium" index="1" src="/images/falling-cards/md-1.jpg" />
    <Card size="small" index="2" src="/images/falling-cards/sm-1.jpg" />
    <Card size="large" index="3" src="/images/falling-cards/lg-2.jpg" />
    <Card size="medium" index="4" src="/images/falling-cards/md-2.jpg" />
    <Card size="small" index="5" src="/images/falling-cards/sm-2.jpg" />
    <Card size="medium" index="6" src="/images/falling-cards/md-3.jpg" />
    <Card size="large" index="7" src="/images/falling-cards/lg-3.jpg" />
    <Card size="small" index="8" src="/images/falling-cards/sm-3.jpg" />
  </Wrapper>
);

export default FallingCards;



// WEBPACK FOOTER //
// ./src/components/ui/FallingCards.js